import axios from 'axios';

// const listaAliquotas = async (amostraLogId: number): Promise<Aliquota[]> => {
//   const res = await axios.get<Aliquota[]>(
//     `/amostras_log/${amostraLogId}/ensaio_aliquotas`,
//   );
//   return res.data;
// };

export default {
  // listaAliquotas,
};
